import { jsx as a } from "react/jsx-runtime";
import * as r from "react";
import { screenReaderOnly as n } from "./screen-reader-only.css-mistica.js";
const o = (param)=>{
    let { children: s  } = param;
    if (r.Children.count(s) === 1) {
        const e = r.Children.only(s);
        if (/*#__PURE__*/ r.isValidElement(e)) return /*#__PURE__*/ r.cloneElement(e, {
            className: e.props.className ? e.props.className + " " + n : n
        });
    }
    return /* @__PURE__ */ a("div", {
        className: n,
        children: s
    });
}, m = o;
export { m as default };
